import messages from "../../messages.i18n";
import { useIntl } from "react-intl";
import { PeekInputCheckbox } from "@piiqtechnologies/ui-components";
import GMBPlaceSelector from "./GMBPlaceSelector";
export const PublishToGMBFormInitialValues = {
    publishStaged: false,
    GMBplace: {
        placeId: "",
        title: "",
    },
};
export const getPublishToGMBFormFields = () => {
    const intl = useIntl();
    return [
        {
            id: "GMBPlace",
            label: intl.formatMessage(messages.spacePublishToGMBFormPropertySelector),
            placeholder: intl.formatMessage(messages.spacePublishToGMBFormPropertySelector),
            required: true,
            fullWidth: true,
            component: GMBPlaceSelector,
        },
        {
            id: "publishStaged",
            label: intl.formatMessage(messages.spacePublishToGMBFormStaged),
            placeholder: "",
            required: false,
            component: PeekInputCheckbox,
            type: "checkbox",
        },
    ];
};
